<template lang="pug">
v-layout(class='wrp' fill-height column)
  v-img(
    v-if='object.avatar_url'
    :src='object.avatar_url'
    :lazy-src='object.avatar_url'
    class='object-background'
  )
    v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
      v-progress-circular(indeterminate color='primary')
  div(class='fader')
  div(class='wrp-scroll' @scroll='onScrollContainer' ref='scrollContainer')
    v-flex(class='wrp-head')
      s-page-title(
        :previous='true'
        :title='object.object_name'
        :subtitle='complex.complex_name'
      )
    v-flex(class='wrp-body')
      v-container(class='pa-0 wrp-list' grid-list-xl fluid)
        v-layout
          v-flex(
            v-for='(section, index) in list'
            :key='index'
            class='wrp-card'
          )
            card(
              :section='section'
              :sectionIndex='index'
              @addFloor='onEditFloor'
              @editFloor='onEditFloor'
              @removeFloor='onRemoveFloor'
              @editSection='onEditSection'
              @removeSection='onRemoveSection'
            )
          v-flex(class='wrp-card emtpy-card')
            v-btn(
              @click='onEditSection'
              color='white'
              class='ma-0'
            )
              v-icon(left) add
              | Добавить подъезд
</template>

<script>
import Card from './Card'
import { mapActions, mapGetters } from 'vuex'

const cache = {
  scrollTop: 0,
  scrollLeft: 0
}

export default {
  name: 'List',

  props: ['objectId', 'id'],

  components: {
    Card
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      try {
        await this.fetchList({
          config: {
            params: {
              object_id: this.objectId
            }
          }
        })
        this.updateScrollPosition()
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка подъездов')
      }
    },

    updateScrollPosition() {
      if (this.$refs.scrollContainer) {
        const { scrollLeft, scrollTop } = cache
        this.$refs.scrollContainer.scroll(scrollLeft, scrollTop, {
          behavior: 'smooth'
        })
      }
    },

    onScrollContainer(ev) {
      cache.scrollTop = ev.target.scrollTop
      cache.scrollLeft = ev.target.scrollLeft
    },

    onEditSection({ id } = {}) {
      this.$router.push({
        name: 'Complexes.Objects.Sections.Edit',
        params: {
          id: this.id,
          objectId: this.objectId,
          sectionId: id
        }
      })
    },

    onEditFloor({ section = {}, floor = {} }) {
      this.$router.push({
        name: 'Complexes.Objects.Sections.Floors.Edit',
        params: {
          id: this.id,
          objectId: this.objectId,
          sectionId: section.id,
          floorId: floor.id
        }
      })
    },

    async onRemoveSection({ id }) {
      if (await this.$confirm('Удалить подъезд?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$showServerErrors(e)
        }

        this.fetch()
      }
    },

    async onRemoveFloor({ id }) {
      if (await this.$confirm('Удалить этаж?')) {
        try {
          await this.destroyFloor({ id })
        } catch (e) {
          this.$showServerErrors(e)
        }

        this.fetch()
      }
    },

    ...mapActions('objects/sections', ['fetchList', 'destroy']),
    ...mapActions('objects/floors', { destroyFloor: 'destroy' })
  },

  computed: {
    complex() {
      return this.complexById(this.id)
    },

    object() {
      return this.objectById(this.objectId)
    },

    list() {
      return this.objectSections(this.objectId)
    },

    ...mapGetters('objects/sections', [
      'isLoading',
      'complexById',
      'objectById',
      'objectSections'
    ])
  }
}
</script>

<style scoped>
.wrp {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  max-width: 100%;
  overflow: hidden;
}
.wrp-head {
  flex: 0;
  padding: 24px;
  padding-left: 0;
  padding-bottom: 0;
}
.wrp-body {
  position: relative;
}
.wrp-scroll {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: auto;
  padding: 24px;
  padding-top: 0;
  padding-right: 0;
  scroll-behavior: smooth;
}
.wrp-card {
  flex: 0;
}
.wrp-list {
  flex: 0;
  width: auto;
  display: inline-flex;
}
.emtpy-card {
  padding-right: 24px !important;
}
.object-background {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.fader {
  top: -550px;
  left: -500px;
  position: absolute;
  width: 1200px;
  height: 1200px;
  background-image: radial-gradient(white, rgba(255, 255, 255, 0) 50%);
}
</style>
